import NotificationsScreen from '../../../containers/Notifications/NotificationsScreen';

export default { Notifications: { component: NotificationsScreen } };
